
import Nav from "@/components/Layouts/Nav.vue";
import Footer from "@/components/Layouts/footer.vue";
import SubNav from "./Subnavigation.vue";
import { ElScrollbar } from 'element-plus'
export default {
  name: "RecommendationsTab",
  components: {
    Nav,
    SubNav,
    Footer,
    ElScrollbar
  },
  data() {
    return {
      routes: [
        "hardcover-fiction",
        "culture",
        "e-book-fiction",
        "science",
        "e-book-nonfiction",
        "crime-and-punishment",
        "religion-spirituality-and-faith",
        "series-books",
        "poetry",
        "others",
      ],
      titles: [
        "Fiction",
        "Culture",
        "E-Book fiction",
        "Science Fiction",
        "Non-Fiction",
        "Crime",
        "Faith",
        "Mystery",
        "Poetry",
        "Others",
      ],
    };
  },
  created() {
    this.fetchBooksByGenre(this.routes[0]);
  },
  methods: {
  fetchBooksByGenre(genre) {
    this.$store.dispatch("fetchBooks", genre);
  },
 },
};
